/**
 * Le choix d'une période, partagé par les écrans qui en demandent une.
 *
 * Extrait de l'écran d'effort le 6 septembre 2026, quand un second écran a eu
 * besoin du même choix — *« les compétences travaillées, par défaut cette
 * semaine, temps configurable »*. Deux sélecteurs écrits séparément finissent
 * par ne plus recouvrir les mêmes dates, et le parent qui passe d'un onglet à
 * l'autre lit deux chiffres qui ne parlent pas de la même semaine.
 *
 * Les présélections et le calcul des bornes vivent dans `ui/periode` : c'est là
 * qu'est écrit pourquoi il n'y a pas de « trimestre ». Le composant a quitté
 * `parent/` le 6 septembre 2026, quand la carte de l'enfant l'a demandé — et la
 * coquille enfant n'importe pas `parent/`.
 */

import { PRESELECTIONS, type Periode, type Preselection } from "@/ui/periode";
import { Card } from "@/ui/primitives";

export function SelecteurDePeriode({
  choix,
  periode,
  max,
  onChoisir,
  onDates,
}: {
  choix: Preselection;
  periode: Periode;
  /** Aujourd'hui : on ne propose pas de compter un travail à venir. */
  max: string;
  onChoisir: (valeur: Preselection) => void;
  onDates: (periode: Periode) => void;
}) {
  return (
    <Card title="La période">
      {/* Un groupe de radios, et non des boutons : le lecteur d'écran annonce
          alors « 2 sur 4 », et la sélection courante existe pour lui aussi. */}
      <div className="periode" role="radiogroup" aria-label="Période">
        {PRESELECTIONS.map((p) => (
          <button
            key={p.valeur}
            type="button"
            role="radio"
            aria-checked={choix === p.valeur}
            className={`periode__choix${choix === p.valeur ? " is-active" : ""}`}
            onClick={() => onChoisir(p.valeur)}
          >
            {p.libelle}
          </button>
        ))}
      </div>

      <div className="periode__dates">
        <label className="field field--inline">
          <span className="field__label">Du</span>
          <input
            type="date"
            className="input"
            value={periode.since}
            max={periode.until || max}
            onChange={(e) => onDates({ ...periode, since: e.target.value })}
          />
        </label>
        <label className="field field--inline">
          <span className="field__label">Au</span>
          <input
            type="date"
            className="input"
            value={periode.until}
            min={periode.since}
            max={max}
            onChange={(e) => onDates({ ...periode, until: e.target.value })}
          />
        </label>
      </div>
    </Card>
  );
}
